module.exports = __webpack_public_path__ + "static/media/head-shot_small.5cfaa319.jpg";